import TetrateLogo from "components/tetrate-logo/tetrate-logo";
export default TetrateLogo;
